import { useCallback } from 'react';
import { exportAndDownloadCSV } from '../../utils/csv-helpers';
import { exportAndDownloadPDF } from '../../utils/pdf-helper';
import { generateStandardFilename } from '@fortress-technology-solutions/fortress-component-library/utils';

const useAffordableWaitlistCSVExport = ({
  filteredHeaders,
  rows,
  hasAnyFilters,
}: {
  filteredHeaders: {
    id: string,
    label: string | { props: { defaultMessage: string } },
  }[],
  rows: { [headerId: string]: { variant: string, value: string | number } },
  hasAnyFilters: boolean,
}) => {
  const onPDFButtonClick = useCallback(() => {
    const fileName = generateStandardFilename({
      type: 'affordable-waitlist',
      extension: 'pdf',
    });

    exportAndDownloadPDF({
      excludedHeaders: ['actions'],
      filteredHeaders,
      fileName,
      rows,
      hasAnyFilters,
      title: 'Affordable Waitlist',
      subtitle: '',
    });
  }, [filteredHeaders, rows, hasAnyFilters]);

  const onCSVButtonClick = useCallback(() => {
    const fileName = generateStandardFilename({
      type: 'affordable-waitlist',
      extension: 'csv',
    });

    exportAndDownloadCSV({
      excludedHeaders: ['actions'],
      filteredHeaders,
      fileName,
      rows,
      hasAnyFilters,
    });
  }, [filteredHeaders, rows, hasAnyFilters]);

  return { onCSVButtonClick, onPDFButtonClick };
};

export default useAffordableWaitlistCSVExport;
